/*
  In-place hover zoom for the main product gallery image (Adidas-style):
  the image itself appears to zoom in, panning as the cursor moves,
  fully contained inside its own frame (.media already clips overflow).
  No lens, no side panel -- nothing else on the page is ever covered.
  Desktop only (hover + fine pointer) - on touch devices this script
  does nothing, the click-to-zoom (PhotoSwipe) modal stays as-is.
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  var ZOOM_FACTOR = 2.2;

  function setupZoom(sliderEl) {
    if (sliderEl.dataset.magnifierReady) return;
    sliderEl.dataset.magnifierReady = 'true';

    function getActiveMedia() {
      // .swiper-slide-active solo existe una vez que Swiper termino de
      // inicializar - antes de eso (primer hover, antes de cualquier
      // click) hay que caer de vuelta al slide marcado por Liquid
      // (data-selected) o simplemente al primero, para que el zoom
      // funcione desde el primer hover sin necesidad de hacer click.
      var activeSlide =
        sliderEl.querySelector('.swiper-slide-active') ||
        sliderEl.querySelector('.swiper-slide[data-selected]') ||
        sliderEl.querySelector('.swiper-slide');
      if (!activeSlide) return null;
      var media = activeSlide.querySelector('.media');
      var img = media ? media.querySelector('img') : null;
      if (!media || !img) return null;
      var link = activeSlide.querySelector('a.product__gallery-toggle[data-pswp-src]');
      var zoomSrc = link ? link.getAttribute('data-pswp-src') : img.currentSrc || img.src;
      return { media: media, zoomSrc: zoomSrc };
    }

    function getLayer(media) {
      var layer = media.querySelector('.product-zoom-layer');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'product-zoom-layer';
        media.appendChild(layer);
      }
      return layer;
    }

    function hide() {
      sliderEl.querySelectorAll('.product-zoom-layer').forEach(function (layer) {
        layer.style.opacity = '0';
      });
    }

    function move(event) {
      var active = getActiveMedia();
      if (!active) {
        hide();
        return;
      }

      var rect = active.media.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;

      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        hide();
        return;
      }

      var layer = getLayer(active.media);
      var originX = (x / rect.width) * 100;
      var originY = (y / rect.height) * 100;

      layer.style.backgroundImage = 'url("' + active.zoomSrc + '")';
      layer.style.backgroundSize = (ZOOM_FACTOR * 100) + '%';
      layer.style.backgroundPosition = originX + '% ' + originY + '%';
      layer.style.opacity = '1';
    }

    sliderEl.addEventListener('mouseenter', move);
    sliderEl.addEventListener('mousemove', move);
    sliderEl.addEventListener('mouseleave', hide);
  }

  function init() {
    document.querySelectorAll('.main-product__media--slider').forEach(setupZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
